import React from 'react';
import PropTypes from 'prop-types';

import SiteHeader from '../components/SiteHeader';
import URLSearchParams from 'url-search-params';

import '../string-polyfill';
import get from 'lodash.get';

export class SiteHeaderConnector extends React.Component {
    static propTypes = {
        bceHeaderUrl: PropTypes.string,
        currencyCode: PropTypes.string,
        dataUrl: PropTypes.string,
        displayTrayJewel: PropTypes.bool,
        fetchUserData: PropTypes.bool,
        fullLocale: PropTypes.string,
        isInverse: PropTypes.bool,
        logoutRedirectUrl: PropTypes.string,
        siteName: PropTypes.string,
        theme: PropTypes.string,
        withoutCountryLanguageSelector: PropTypes.bool,
        withoutCurrencySelector: PropTypes.bool,
        withoutFlags: PropTypes.bool,
        withoutHelpLinks: PropTypes.bool,
        withoutInbox: PropTypes.bool,
        withoutListYourProperty: PropTypes.bool,
        withoutLogin: PropTypes.bool,
        withoutScratchpad: PropTypes.bool,
        withoutSearch: PropTypes.bool,
        withoutTraveler: PropTypes.bool,
    };

    static defaultProps = {
        bceHeaderUrl: 'bceHeader',
        currencyCode: 'JPY',
        dataUrl: '/api/header',
        displayTrayJewel: false,
        fetchUserData: true,
        fullLocale: 'en_US_HA',
        siteName: 'homeaway_us'
    };

    constructor(props) {
        super(props);

        this.state = {
            ...props.data,
        };
    }

    componentDidMount() {
        if (this.props.fetchUserData) {
            this.getUserData();
        }
    }

    componentWillReceiveProps(props) {
        if (this.props.fetchUserData !== props.fetchUserData
            && props.fetchUserData) {
            this.getUserData(props);
        }
    }

    formatDataUrl(dataUrl) {
        dataUrl = dataUrl.startsWith('/') ? dataUrl : `/${dataUrl}`;
        dataUrl = dataUrl.endsWith('/') ? dataUrl : `${dataUrl}/`;

        return dataUrl;
    }

    getUserData(props = this.props) {
        let dataUrl = this.formatDataUrl(props.dataUrl);
        let url = `${dataUrl}${props.bceHeaderUrl}`;
        let params = new URLSearchParams();

        params.append('site', props.siteName);

        /* istanbul ignore else */
        if (props.fullLocale) {
            params.append('locale', props.fullLocale);
        }

        /* istanbul ignore else */
        if (props.isInverse) {
            params.append('feature', 'theme-inverse');
        }

        /* istanbul ignore else */
        if (get(window, '__ABACUS__.HA_GX_COUNTRY_LANGUAGE_SELECTOR.value') >= 1 || get(window, '__ABACUS__.HA_GX_COUNTRY_LANGUAGE_SELECTOR_NL.value') === 1) {
            params.append('feature', 'country-language-selector');
        }

        const currencySelectorVariant = get(window, '__ABACUS__.HA_GX_CURRENCY_SELECTOR.value');
        /* istanbul ignore else */
        if (currencySelectorVariant === 1) {
            params.append('feature', 'currency-selector');
        } else if (currencySelectorVariant === 2) {
            params.append('feature', 'currency-selector2');
        }

        /* istanbul ignore else */
        if (get(window, '__ABACUS__.HA_PTA_AFFILIATE_CO_BRAND.value') === 1 && window.location.search.includes('utm_campaign=homeaway_test_publisher_1100l560')) {
            console.info('AB Test is on and campaign is included');
            params.append('partner', 'automobile_association');
        }

        let request = new Request(`${url}?${params}`, {
            credentials: 'same-origin',
        });

        // eslint-disable-next-line complexity
        return fetch(request).then((response) => response.json()).then((response) => {
            let data = response && response.header;

            if (data) {
                if (data.traveler || data.owner) {
                    data.login = false;
                }

                if (!data.flags) {
                    data.flags = null;
                }

                if (!data.globalizationSelector) {
                    data.globalizationSelector = null;
                }
                this.setState(data);
            }
        }).catch(/* istanbul ignore next */(error) => {
            console.log(error); // eslint-disable-line no-console
        });
    }

    render() {
        /**
         * @type {any} siteHeaderProps
         */
        let {children, ...siteHeaderProps} = this.props;

        delete siteHeaderProps.data;
        delete siteHeaderProps.dataUrl;
        delete siteHeaderProps.fetchUserData;

        return (
            <SiteHeader {...siteHeaderProps} {...this.state}>{children}</SiteHeader>
        );
    }
}
